import React from "react";

export function CopyIcon(props: React.SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66666 4.4444C1.66666 2.91028 2.91031 1.66663 4.44443 1.66663H12.0833C13.6174 1.66663 14.8611 2.91028 14.8611 4.4444V5.83329H15.5555C17.0897 5.83329 18.3333 7.07695 18.3333 8.61107V15.5555C18.3333 17.0896 17.0897 18.3333 15.5555 18.3333H8.6111C7.07698 18.3333 5.83332 17.0896 5.83332 15.5555V14.8611H4.44443C2.91031 14.8611 1.66666 13.6174 1.66666 12.0833V4.4444ZM5.83332 13.4722V8.61107C5.83332 7.07695 7.07698 5.83329 8.6111 5.83329H13.4722V4.4444C13.4722 3.67734 12.8504 3.05551 12.0833 3.05551H4.44443C3.67737 3.05551 3.05555 3.67734 3.05555 4.4444V12.0833C3.05555 12.8504 3.67737 13.4722 4.44443 13.4722H5.83332ZM8.6111 7.22218C7.84404 7.22218 7.22221 7.84401 7.22221 8.61107V15.5555C7.22221 16.3226 7.84404 16.9444 8.6111 16.9444H15.5555C16.3226 16.9444 16.9444 16.3226 16.9444 15.5555V8.61107C16.9444 7.84401 16.3226 7.22218 15.5555 7.22218H8.6111Z"
        fill="currentColor"
      />
    </svg>
  );
}
